import { request, download } from '@/utils/request'

const base = "/vfss";
export function upload (data) {
  return request({
    url: `${base}/file/upload`,
    //url: '/upload.json',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000,
    data: data
  })
}

// 文件列表 上传
export function getFileList(data) {
  return request({
    url: `/sys-file-ref/file-upload-list`,
    method: 'get',
    params: data
  })
}

// 文件列表 下载
export function getFileDownloadList(data) {
  return request({
    url: `/sys-file-ref/file-list`,
    method: 'get',
    params: data
  })
}

// 上传
export function uploadOne(data) {
  return request({
    url: `/sys-file-ref/file-upload`,
    method: 'post',
    data: data
  })
}

// 批量上传
export function batchUpload(data) {
  return request({
    url: `/sys-file-ref/full-file-upload`,
    method: 'post',
    data: data
  })
}

// 删除文件
export function fileDelete(data) {
  return request({
    url: `/sys-file-ref/file-batch-delete`,
    method: 'post',
    data: data
  })
}

// 锁定文件
export function fileLocked(data) {
  return request({
    url: `/sys-file-ref/file-locked`,
    method: 'post',
    data: data
  })
}

// 下载文件
export function attachmentDownload(data) {
  return download({
    url: `/sys-file-ref/file-download`,
    method: 'post',
    data: data
  })
}

//查询产品研发部下所有用户信息
export function queryProductDeptUser(data) {
  return request({
    url:`${base}/dingUser/query-product-dept-user`,
    method: 'post',
    data: data
  })
}

//查询用户列表
export function getDingUserList(data) {
  return request({
    url:`${base}/dingUser/get-list`,
    method: 'post',
    data: data
  })
}

/** 根据字典类型编码获取字典项列表
 *	@param { Object } data					-参数 
 *	@param { string } data.dictType	- BANK_TYPE ：银行类型 ；VEHICLE_BRAND ：车辆品牌；WAREHOUSE_TYPE：仓库类型；MANUFACTURER：主机厂；PROJECT_WARNING：项目预警项
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/8538
 */
export function dict(data) {
  return request({
    url: `${base}/dict/data/items`,
    method: 'post',
    data
  })
}

/** 查询当前用户下的经销商
 *	@param { Object } data					-参数 
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/8634
 */
export function getDealerInfoByUser(data) {
  return request({
    url: `${base}/dealer_info/getDealerInfoByUser`,
    method: 'post',
    data
  })
}

/** 查询当前用户下的银行
 *	@param { Object } data					-参数 
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/8640
 */
export function getBankInfoByUser(data) {
  return request({
    url: `${base}/bank_info/getBankInfoByUser`,
    method: 'post',
    data
  })
}

/** 获取机构类型下拉列表
 *	@param { Object } data					-参数 
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/8640
 */
export function getInstitutionList(data) {
  return request({
    url: `${base}/user/institutionList`,
    method: 'post',
    data
  })
}

/** 获取地址字符串 逆地址解析
 *	@param { Object } data					-参数 
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/8787
 */
export function getAddressString(data) {
  return request({
    url: `${base}/api/location/address-string`,
    method: 'post',
    data
  })
}

/** 文件上传到兴业
 *	@param { Object } data					-参数 
 * 	@tutorial http://192.168.2.230:19000/project/164/interface/api/11007
 */
export function uploadToCib(data) {
  return request({
    url: `${base}/file/uploadToCib`,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000,
    data: data
  })
}
